export enum AppPaths {
	LOGIN = 'login',
	RESET_PASSWORD = 'reset-password',
	SET_PASSWORD = 'set-password',

	ACCOUNT = 'account',

	CREATOR = 'creator',

	ORDERS = 'orders',
	ARCHIVED_ORDERS = 'archived-orders',

	DOWNLOADABLE_FILES = 'downloadable-files',

	PRODUCT_TYPES = 'product-types',
}
